/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Complete_ToastInputs */



/**
* | output |
* | --- |
* | "Video export is now complete" |
*
* @param {Video_Export_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_complete_toast = /** @type {((inputs?: Video_Export_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'exportation video est terminee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Videoexport ist nun abgeschlossen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'esportazione del video è ora completa")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт видео завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La exportación de vídeo ahora está completa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频导出已完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオのエクスポートが完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो निर्यात अब पूरा हो गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A exportação do vídeo já foi concluída.")
	return /** @type {LocalizedString} */ ("Video export is now complete")
});